<template>
	<div class="tl-item">
		<div class="tlx-divider">
			<div class="tlx-point"></div>
			<div class="tlx-line"></div>
		</div>
		<div class="tlx-txt">
			<div class="f-16 f-semi tlx-title" v-if="title !== ''">{{ title }}</div>
			<div class="tlx-extra f-14 f-c-midgrey">
				<div class="tlx-note" v-if="note !== ''">
					<span>CATATAN:</span>{{ note }}
				</div>
				<div class="d-flex flex-wrap" v-if="images.length > 0">
					<div v-for="foto in images">
						<div
							v-if="foto.cloud_thumb === '' || foto.cloud_thumb === null"
							class="m-1"
							style="height: 52px; width: 52px; border-radius: 4px; background-position: center; background-size: cover"
							:style="{backgroundImage: 'url(' + baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name +')'}"
							@click="previewPhoto(baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
						>
						</div>
						<div
							v-else
							class="m-1"
							style="height: 52px; width: 52px; border-radius: 4px; background-position: center; background-size: cover"
							:style="{backgroundImage: 'url(' + baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_thumb +')'}"
							@click="previewPhoto(baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
						>
						</div>
					</div>
				</div>
			</div>
			<div class="f-14 f-c-midgrey tlx-desc" v-if="subTitle !== ''">{{ subTitle }}</div>
			<div class="f-12 f-c-midgrey tlx-date" v-if="date !== ''">
				{{ $moment(dateRaw).format('dddd') }}, {{ date }}
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" :id="modalId">
			<div class="modal-dialog m-0" role="document">
				<div class="modal-content" style="border-radius: 0">
					<div
						class="modal-body p-0 vh-100 d-flex justify-content-center align-items-center"
						style="background-color: black;">
						<img src="@/assets/icons/close-white.svg" alt=""
						     style="position:absolute; top: 20px; left: 20px; border-radius: 50%; background-color: #00000080"
						     @click="previewPhotoClose"
						>
						<iframe v-if="fileContentType.includes('video')" style="width: 100vw; height: 100vh"
						        :src="fileUrl" title="description"></iframe>
						<img v-else :src="fileUrl" class="w-100" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTransaksiStatusTahapanLayanan",
	props: {
		title: String,
		subTitle: String,
		date: String,
		dateRaw: String,

		note: String,
		images: Array,
	},
	data() {
		return {
			baseUrlCloudBucket: "https://storage.googleapis.com/",
			fileUrl: "",
			fileContentType: "",
			modalId: "modal-preview-" + Math.floor(Math.random() * 10000).toString(),
		}
	},
	methods: {
		previewPhoto(selectedPhoto, contentType) {
			this.fileUrl = selectedPhoto
			this.fileContentType = contentType
			$("#" + this.modalId).modal("show")
		},
		previewPhotoClose() {
			$("#" + this.modalId).modal("hide")
			this.fileUrl = ""
			this.fileContentType = ""
		}
	}
}
</script>